// extracted by mini-css-extract-plugin
module.exports = {"demo_video":"DemoVideo_demo_video__X7leA","description":"DemoVideo_description__nb4pm","video_container":"DemoVideo_video_container__wb3i7","video":"DemoVideo_video__OMzmz"};